export default "__VITE_ASSET__ggnWfagJ__"